import React, { useState, useEffect } from 'react';
import { RegistrationForm } from './RegistrationForm';

export function EventDetailModal({ event, isOpen, onClose }) {
  const [showRegistration, setShowRegistration] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // Check if user is logged in by checking localStorage
    const sessionToken = localStorage.getItem('session_token');
    const userEmail = localStorage.getItem('user_email');
    const userId = localStorage.getItem('user_id');
    setIsLoggedIn(!!(sessionToken && userEmail));
    
    if (userId) {
      try {
        setUserData({ id: userId });
        
        // Fetch favorites
        fetch(`/api/users/${userId}/favorites`, {
          headers: {
            'x-session-token': sessionToken
          }
        })
        .then(res => res.json())
        .then(data => {
          if (data.success && data.events.some(e => e.id === event?.id)) {
            setIsFavorite(true);
          }
        });
      } catch (e) {}
    }
  }, [isOpen, event]);

  const handleFavoriteToggle = () => {
    if (!userData) return;
    const sessionToken = localStorage.getItem('session_token');
    const method = isFavorite ? 'DELETE' : 'POST';
    const url = isFavorite 
      ? `/api/users/${userData.id}/favorites/${event.id}` 
      : `/api/users/${userData.id}/favorites`;

    fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json',
        'x-session-token': sessionToken
      },
      body: isFavorite ? undefined : JSON.stringify({ eventId: event.id })
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setIsFavorite(!isFavorite);
      }
    });
  };

  if (!isOpen || !event) return null;

  const isPast = new Date(event.date) < new Date();

  const handleRegisterClick = () => {
    if (!isLoggedIn) {
      // Redirect to login page
      window.location.href = '/login';
      return;
    }
    setShowRegistration(true);
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          width: '90%',
          maxWidth: '700px',
          maxHeight: '90vh',
          overflow: 'auto',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', padding: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: '8px 8px 0 0' }}>
          <h5 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>{event.name}</h5>
          <button
            type="button"
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '28px',
              cursor: 'pointer',
              padding: 0,
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: '30px' }}>
          {showRegistration ? (
            <RegistrationForm 
              event={event} 
              onClose={() => setShowRegistration(false)}
              onSuccess={() => {
                setShowRegistration(false);
                onClose();
              }}
              isGuest={false}
            />
          ) : (
            <>
              <div style={{ marginBottom: '30px' }}>
                <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#333' }}>{event.description}</p>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <h6 style={{ color: '#666', marginBottom: '8px', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>📅 Date</h6>
                  <p style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>{new Date(event.date).toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
                </div>
                <div>
                  <h6 style={{ color: '#666', marginBottom: '8px', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>⏰ Time</h6>
                  <p style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>{event.time}</p>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <h6 style={{ color: '#666', marginBottom: '8px', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>📍 Location</h6>
                  <p style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>{event.location}</p>
                </div>
                <div>
                  <h6 style={{ color: '#666', marginBottom: '8px', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>👥 Capacity</h6>
                  <p style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>
                    {Number(event.registrations || 0)} / {Number(event.capacity || 0)}
                    <span style={{ marginLeft: '10px' }}>
                      {Number(event.registrations || 0) >= Number(event.capacity || 0) ? (
                        <span style={{ backgroundColor: '#dc3545', color: 'white', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>Full</span>
                      ) : (
                        <span style={{ backgroundColor: '#28a745', color: 'white', padding: '4px 12px', borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>{Number(event.capacity || 0) - Number(event.registrations || 0)} spots left</span>
                      )}
                    </span>
                  </p>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                <div>
                  <h6 style={{ color: '#666', marginBottom: '8px', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Status</h6>
                  <span style={{ backgroundColor: isPast ? '#6c757d' : '#28a745', color: 'white', padding: '6px 16px', borderRadius: '20px', display: 'inline-block', fontSize: '14px', fontWeight: 'bold' }}>
                    {isPast ? 'Past Event' : 'Upcoming Event'}
                  </span>
                </div>
                <div>
                  <h6 style={{ color: '#666', marginBottom: '8px', fontSize: '14px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Ticket Price</h6>
                  <span style={{ backgroundColor: Number(event.price) > 0 ? '#ffc107' : '#17a2b8', color: Number(event.price) > 0 ? '#000' : '#fff', padding: '6px 16px', borderRadius: '20px', display: 'inline-block', fontSize: '14px', fontWeight: 'bold' }}>
                    {Number(event.price) > 0 ? `$${Number(event.price).toFixed(2)}` : 'Free'}
                  </span>
                </div>
              </div>

              {event.image_url && (
                <div style={{ marginBottom: '20px' }}>
                  <img src={event.image_url} alt={event.name} style={{ width: '100%', maxHeight: '300px', objectFit: 'cover', borderRadius: '8px' }} />
                </div>
              )}
            </>
          )}
        </div>

        <div style={{ padding: '20px', borderTop: '1px solid #eee', display: 'flex', gap: '10px', justifyContent: 'flex-end', background: '#f9f9f9', borderRadius: '0 0 8px 8px' }}>
          {isLoggedIn && !showRegistration && (
            <button 
              type="button" 
              onClick={handleFavoriteToggle}
              style={{ 
                padding: '10px 20px', 
                backgroundColor: isFavorite ? '#ffc107' : '#fff', 
                color: isFavorite ? '#000' : '#6c757d', 
                border: '1px solid #ced4da', 
                borderRadius: '6px', 
                cursor: 'pointer', 
                fontSize: '14px', 
                fontWeight: '500' 
              }}
            >
              {isFavorite ? '★ Favorited' : '☆ Add to Schedule'}
            </button>
          )}
          <button type="button" onClick={onClose} style={{ padding: '10px 20px', backgroundColor: '#6c757d', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}>
            {showRegistration ? 'Back' : 'Close'}
          </button>
          {!event.allow_registrations ? (
            <button 
              type="button" 
              disabled
              style={{ padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '6px', cursor: 'not-allowed', fontSize: '14px', fontWeight: '500', opacity: 0.6 }}
            >
              Registrations Closed
            </button>
          ) : event.registrations >= event.capacity ? (
            <button 
              type="button" 
              disabled
              style={{ padding: '10px 20px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '6px', cursor: 'not-allowed', fontSize: '14px', fontWeight: '500', opacity: 0.6 }}
            >
              Event Full
            </button>
          ) : !showRegistration && (
            <button 
              type="button" 
              onClick={handleRegisterClick}
              style={{ padding: '10px 20px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}
              title={isLoggedIn ? 'Register for this event' : 'Please login to register'}
            >
              {isLoggedIn ? 'Register Now' : 'Login to Register'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
